import axios from '../axios'

// 閲覧可能なコース一覧（Enrollmentベースでサーバ側が絞り込み）
const getCoursesApi = async () => {
  return await axios.get('api/lms/courses')
}

export default getCoursesApi
